import '@styles/views/csc.less';
import AppBannerCSD from '@components/app/appBannerCSD';
//import AppAdvantage from '@components/app/appAdvantage';
import AppCivilStationDesigner from '@components/app/appCivilStationDesigner';
//import AppDisplayDesc from '@components/app/appDisplayDesc';
//import AppBimWindows from '@components/app/appBimWindows';
import AppFooter from '@components/app/appFooter';

const CSD = () => {
  return (
    <div className={'introduce-page'}>
      <AppBannerCSD />
      <AppCivilStationDesigner />
      {/* <AppBimWindows /> */}
      {/* <AppAdvantage showDesc  style={{ marginTop: '30px' }}/> */}
      {/* <AppDisplayDesc /> */}
      <AppFooter />
    </div>
  );
};

export default CSD;
